/**
 * Cycle de vie d'un ordre (doc 01, § 7.1).
 *
 * Partagé entre l'API, qui refuse toute transition hors de cette table, et
 * l'écran des ordres, qui n'offre une action en lot que sur les ordres
 * capables de la recevoir. Deux tables finiraient par diverger : le bouton
 * proposerait ce que le serveur refuse.
 */
export const STATUTS_ORDRE = [
  'BROUILLON',
  'A_VALIDER',
  'VALIDE',
  'TRANSMIS',
  'DENOUE',
  'REJETE',
  'ANNULE',
] as const;

export type CodeStatutOrdre = (typeof STATUTS_ORDRE)[number];

export const TRANSITIONS_ORDRE: Record<CodeStatutOrdre, readonly CodeStatutOrdre[]> = {
  BROUILLON: ['A_VALIDER', 'ANNULE'],
  A_VALIDER: ['VALIDE', 'BROUILLON', 'ANNULE'],
  VALIDE: ['TRANSMIS', 'ANNULE'],
  // Dénoué au sens du rapprochement, et non « exécuté » : une situation
  // postérieure à la transmission reflète le sort de l'ordre, quel qu'il ait
  // été. Le rejet reste ouvert pour la non-exécution constatée autrement.
  TRANSMIS: ['DENOUE', 'REJETE'],
  DENOUE: [],
  REJETE: [],
  ANNULE: [],
};

/** Un statut inconnu n'autorise rien. */
export function transitionOrdrePermise(depuis: string, vers: CodeStatutOrdre): boolean {
  return TRANSITIONS_ORDRE[depuis as CodeStatutOrdre]?.includes(vers) ?? false;
}
